<template>
  <v-card tile>
    <v-toolbar :flat="!inDialog">
      <v-btn
        v-if="inDialog"
        icon
        @click="closeDialog"
      >
        <v-icon>{{ mdiClose }}</v-icon>
      </v-btn>
      <v-toolbar-title v-if="!isSearchMode">
        {{ $t('TrainingClient.SubordinateInternalProposalForms') }}
      </v-toolbar-title>
      <v-text-field
        v-if="isSearchMode"
        v-model="search"
        :append-icon="mdiMagnify"
        outlined
        clearable
        :label="$t('PublicServant.Action.Search')"
        single-line
        hide-details
        full-width
        autofocus
      />
      <v-spacer v-if="!isSearchMode" />
      <v-toolbar-items>
        <v-btn
          v-if="!isSearchMode"
          icon
          @click="isSearchMode = true"
        >
          <v-icon>
            {{ mdiMagnify }}
          </v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <v-data-table
      :headers="headers"
      :items="proposals"
      :search="search"
      item-key="internalProposeFormDetailId"
      :footer-props="{
        disableItemsPerPage: true,
        'items-per-page-text' : $t('DataTable.itemsPerPage')
      }"
    >
      <template v-slot:top>
        <div class="px-4 pt-2">
          <v-row align="center">
            <v-col
              cols="12"
              md="6"
            >
              <v-select
                v-model="yearSelect"
                :items="years"
                :label="$t('PublicServant.LeaveAndAbsent.Year')"
                hide-details
                @change="getProposalByYear(yearSelect)"
              />
            </v-col>
          </v-row>
        </div>
      </template>
      <template slot="no-data">
        <div>{{ $t('PublicServant.NoData') }}</div>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { coursesModule } from '../../../store/moduleName'
import courses from '../../../store/modules/training/courses'
import store from '../../../store'
import { mapState } from 'vuex'
import { mdiClose, mdiMagnify } from '@mdi/js'

if (!store.state[coursesModule]) store.registerModule(coursesModule, courses)

export default {
  props: {
    inDialog: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      mdiMagnify: mdiMagnify,
      mdiClose: mdiClose,
      isSearchMode: false,
      search: null,
      yearSelect: null
    }
  },
  computed: {
    years: function () {
      let year = new Date().getFullYear()
      return [
        {
          text: (year - 1) + '-' + year
        },
        {
          text: year + '-' + (year + 1)
        },
        {
          text: (year + 1) + '-' + (year + 2)
        }
      ]
    },
    headers: function () {
      return [
        {
          text: this.$t('TrainingClient.Identity.name'),
          value: this.$chPtField('chinName')
        },
        {
          text: this.$t('TrainingClient.InernalPropose.trainingGoal'),
          value: this.$chPtField('chinCourseAbilityBrief')
        },
        {
          text: this.$t('TrainingClient.CourseList'),
          value: this.$chPtField('chinDraftYearCourseName')
        },
        {
          text: this.$t('TrainingClient.InernalPropose.trainingReasonShort'),
          value: this.$chPtField('chinObjectiveTypeDesc')
        },
        {
          text: this.$t('TrainingClient.InernalPropose.classQuarter'),
          value: this.$chPtField('chinTimeUnit')
        }
      // {
      //   text: this.$t('TrainingClient.ProcessStep'),
      //   value: 'c'
      // }
      ]
    },
    ...mapState({
      proposals: state => state[coursesModule].yearProposalForm
    })
  },
  created () {
    let year = new Date().getFullYear()
    this.yearSelect = year + '-' + (year + 1)
    this.$store.dispatch(coursesModule + '/getProposalFormReport', ~~year)
    // this.$store.dispatch(coursesModule + '/getProposalFormReportByYear', ~~year)
    // this.getProposalByYear(year)
  },
  mounted: function () {

  },
  methods: {
    closeDialog: function () {
      this.$emit('closeDialog')
      this.search = null
      this.isSearchMode = false
    },
    getProposalByYear: function (year) {
      let tempYear = year + ''
      tempYear = tempYear.substr(0, 4)
      this.$store.dispatch(coursesModule + '/getProposalFormReportByYear', ~~tempYear)
    }
  }
}
</script>
